<div class="module-outlet">
  <h2><fa-icon icon="envelope"></fa-icon> Service Bus Namespaces</h2> 
  <div class="container-fluid">
    <kendo-grid
      #grid
      [data]="view | async"
      [style.height.%]="100"
      [pageSize]="gridState.take"
      [skip]="gridState.skip"
      [sort]="gridState.sort"
      [pageable]="false"
      [sortable]="false"
      [filterable]="false"
      (dataStateChange)="onStateChange($event)"
      [navigable]="true"
      [loading]="loading"
      [resizable]="true">

      <kendo-grid-column
        field="Id"
        title="ID"
        width="100"
        [editable]="false"
        [hidden]="true">
      </kendo-grid-column>
    
      <kendo-grid-column
        width="100"
        field="ServiceCode"
        title="Service">
      </kendo-grid-column>

      <kendo-grid-column
        width="100"
        field="EnvironmentCode"
        title="Environment">
      </kendo-grid-column>

      <kendo-grid-column
        width="100"
        field="TenantCode"
        title="Tenant">
      </kendo-grid-column>

      <kendo-grid-column
        width="300"
        field="Namespace"
        title="Namespace">
      </kendo-grid-column>     

      <kendo-grid-column
        width="150"
        field="AccessKeyName"
        title="Access Key Name">
      </kendo-grid-column>
          
      <div *kendoGridDetailTemplate="let dataItem">
        <app-queues
          [connection]="dataItem">
        </app-queues>
        <br />
        <app-topics
          [connection]="dataItem">
        </app-topics>
      </div> 
    </kendo-grid>
  </div>
</div>
